import './app.css';
import { setupProblemDetailsDialog } from './problemDetails.ts';
import '@datapolarna/tooltip';
import { setupFontawesome } from './fontawesome.ts';
import { setupDialog } from './dialog.ts';

export function setupApp() {
    const problemDetailsDialog = setupProblemDetailsDialog();

    setupFontawesome();
    setupDialog();

    return {
        problemDetailsDialog
    };
}

